import { render, staticRenderFns } from "./OrdenCompra.vue?vue&type=template&id=763b3f2a&"
import script from "./OrdenCompra.vue?vue&type=script&lang=js&"
export * from "./OrdenCompra.vue?vue&type=script&lang=js&"
import style0 from "./OrdenCompra.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports